export const ItemSearchType = Object.freeze({
  Id: 0,
  Title: 1,
  Contributor: 2,
  SkuOrIsbn: 3
})
